module.exports = __webpack_public_path__ + "static/direction-7ce88101bd8f0b8ea3910338324808c6.jpg";